export const REACT_APP_API_URL = 'https://api.portal.openzk.net/';

export const REACT_APP_CHAIN_ID = parseInt(process.env.REACT_APP_CHAIN_ID);
export const REACT_APP_ETH_CHAIN_ID_HEX =
  process.env.REACT_APP_ETH_CHAIN_ID_HEX;

export const REACT_APP_DAI_TOKEN = process.env.REACT_APP_DAI_TOKEN;

export const REACT_APP_OZUSD_TOKEN = process.env.REACT_APP_OZUSD_TOKEN;
export const REACT_APP_OZUSD_L2_TOKEN = process.env.REACT_APP_OZUSD_L2_TOKEN;
export const REACT_APP_OZUSD_L2_WITHDRAW_CONTRACT =
  process.env.REACT_APP_OZUSD_L2_WITHDRAW_CONTRACT;
export const REACT_APP_OZETH_L2_TOKEN = process.env.REACT_APP_OZETH_L2_TOKEN;

export const REACT_APP_OZK_TOKEN = process.env.REACT_APP_OZK_TOKEN;
export const REACT_APP_PERMIT_PAYMASTER_ADDRESS =
  process.env.REACT_APP_PERMIT_PAYMASTER_ADDRESS ||
  '0xdbE20ec02e6416e1cE0f9cA3FC6deF923a9CBb6A';

const DEFAULT_TRANSFER_WALLET = '0x0C78AF0fb1F4E09dF9421ba9abD75C4dc018DB05';
export const REACT_APP_TRANSFER_WALLETS = (
  process.env.REACT_APP_TRANSFER_WALLETS || DEFAULT_TRANSFER_WALLET
)
  .split(',')
  .map((wallet) => wallet.trim().toLowerCase())
  .filter(Boolean);
export const REACT_APP_OZK_STAKING_TOKEN =
  process.env.REACT_APP_OZK_STAKING_TOKEN;
export const REACT_APP_TOKEN_DISTRIBUTOR =
  process.env.REACT_APP_TOKEN_DISTRIBUTOR;

//TODO not used need to be removed
export const REACT_APP_OPENZK_STAKING =
  '0x03475bf811f58C27589843061F9f8AA8Ff22aF46';
export const REACT_APP_OPENZK_STAKING_ERC20 =
  '0x6458ADAb4f4d1aFd009133FBcC00da8F3f56CD1a';
export const REACT_APP_STAKE_TOPIC0 =
  '0x63602d0ecc7b3a0ef7ff1a116e23056662d64280355ba8031b6d0d767c4b4458';
export const REACT_APP_STAKE_NEWERC20_TOPIC0 =
  '0xdcbc1c05240f31ff3ad067ef1ee35ce4997762752e3a095284754544f4c709d7';

export const REACT_APP_ETH_RPC = process.env.REACT_APP_ETH_RPC;
export const REACT_APP_ETH_API_URL = process.env.REACT_APP_ETH_API_URL;
export const REACT_APP_ETH_TRANSACTION = process.env.REACT_APP_ETH_TRANSACTION;
export const REACT_APP_API_KEY = process.env.REACT_APP_API_KEY;

export const REACT_APP_OPENZK_CHAIN_ID = parseInt(
  process.env.REACT_APP_OPENZK_CHAIN_ID,
);
export const REACT_APP_OPENZK_CHAIN_ID_HEX =
  process.env.REACT_APP_OPENZK_CHAIN_ID_HEX;

/** Caldera-style JSON-RPC is often mounted at `/http`; bare origin can confuse clients. */
const DEFAULT_OPENZK_RPC = 'https://rpc.openzk.net/http';
function normalizeOpenZkRpcUrl(raw) {
  if (!raw || typeof raw !== 'string') {
    return DEFAULT_OPENZK_RPC;
  }
  const trimmed = raw.trim();
  if (!trimmed.startsWith('http')) {
    return DEFAULT_OPENZK_RPC;
  }
  try {
    const u = new URL(trimmed);
    if (
      u.hostname === 'rpc.openzk.net' &&
      (u.pathname === '/' || u.pathname === '')
    ) {
      u.pathname = '/http';
      return u.href.replace(/\/+$/, '');
    }
    return trimmed;
  } catch {
    return DEFAULT_OPENZK_RPC;
  }
}

export const REACT_APP_OPENZK_RPC = normalizeOpenZkRpcUrl(
  process.env.REACT_APP_OPENZK_RPC,
);

//TODO not used need to be removed
export const REACT_APP_OPENZK_TOKEN =
  '0x09130a60D105428547cd477051Fb84E753AF9686';

export const REACT_APP_TEAM_MEMBERS_JSON =
  process.env.REACT_APP_TEAM_MEMBERS_JSON;

export const REACT_APP_BLOCK_EXPLORER_OPEN_ZK_URL =
  process.env.REACT_APP_BLOCK_EXPLORER_OPEN_ZK_URL;
export const REACT_APP_BLOCK_EXPLORER_OPEN_ZK_API =
  process.env.REACT_APP_BLOCK_EXPLORER_OPEN_ZK_API;

export const REACT_APP_LIQUIDITY_MANAGER =
  process.env.REACT_APP_LIQUIDITY_MANAGER;
export const REACT_APP_AIRDROP_START_DATE =
  process.env.REACT_APP_AIRDROP_START_DATE;
export const REACT_APP_AIRDROP_END_DATE =
  process.env.REACT_APP_AIRDROP_END_DATE;
